import { useEffect, useMemo, useRef } from "react";
import { Skeleton } from "@mui/material";
import { chatTime, groupChatMessages, isOwnChatMessage } from "../lib/presentation";

/** Patterned history and neutral bubbles use the storefront's chat visual tokens. */
export default function ChatMessageList({ messages, currentUserId, loading }) {
  const scroll = useRef(null);
  const previousCount = useRef(0);
  const groups = useMemo(() => groupChatMessages(messages), [messages]);
  useEffect(() => {
    const node = scroll.current;
    if (!node) return;
    const nearBottom = node.scrollHeight - node.scrollTop - node.clientHeight < 140;
    if (!previousCount.current || nearBottom) node.scrollTop = node.scrollHeight;
    previousCount.current = messages.length;
  }, [messages.length]);
  return <div ref={scroll} className="dk-chat-message-scroll" role="log" aria-label="پیام‌های گفتگو" aria-live="polite">
    {loading ? <div className="dk-chat-message-loading">
      <Skeleton variant="rounded" width="55%" height={50} />
      <Skeleton variant="rounded" width="40%" height={60} />
      <Skeleton variant="rounded" width="65%" height={50} />
    </div> : !groups.length ? <p className="dk-chat-empty">هنوز پیامی در این گفتگو وجود ندارد.</p> :
      groups.map((group) => <div className="dk-chat-message-day" key={group.key}>
        <div className="dk-chat-day-label" role="separator" aria-label={group.label}><span>{group.label}</span></div>
        {group.messages.map((message) => {
          const mine = isOwnChatMessage(message, currentUserId);
          return <div key={message.id} className={`dk-chat-message-row${mine ? " is-own" : ""}`}>
            <div className="dk-chat-bubble" data-message-id={message.id}>
              <p className="dk-chat-message-text" dir="auto">{typeof message.message === "string" ? message.message : ""}</p>
              <div className="dk-chat-message-meta"><time>{chatTime(message.createdAt)}</time>
                {mine && <span aria-label={message.isSeen ? "دیده شده" : "ارسال شده"}>{message.isSeen ? "✓✓" : "✓"}</span>}
              </div>
            </div>
          </div>;
        })}
      </div>)}
  </div>;
}
